import axiosApiClient from "..";
import { handleError } from "../../utils/errors";

const BASE_URL = "/payment";

class PaymentService {
  checkNewPayment = async () => {
    try {
      const response = await axiosApiClient.get(`${BASE_URL}/new-payment`);
      if (response.status !== 200) {
        throw new Error();
      }

      const { newPayment } = response.data.data;
      return { newPayment };
    } catch (err) {
      throw handleError(
        err,
        "Error occurred while fetching new payment's info."
      );
    }
  };

  getRequestWithdrawals = async ({ nextPage = 1 }) => {
    try {
      const response = await axiosApiClient.get(
        `${BASE_URL}/withdrawal?page=${nextPage}`
      );
      if (response.status !== 200) {
        throw new Error();
      }

      const { requests, total, maxReached, page } = response.data.data;
      return { requests, total, maxReached, page };
    } catch (err) {
      console.log(err);
      throw handleError(
        err,
        "Error occurred while fetching requests withdrawal."
      );
    }
  };

  createRequestWithdrawal = async ({ amount, walletAddress }) => {
    try {
      const response = await axiosApiClient.post(`${BASE_URL}/withdrawal`, {
        amount,
        walletAddress,
      });
      if (response.status !== 200) {
        throw new Error();
      }

      const { request } = response.data.data;
      return { request };
    } catch (err) {
      throw handleError(
        err,
        "Error occurred while creating requests withdrawal."
      );
    }
  };
}

const paymentService = new PaymentService();

export default paymentService;
